import { NotificationManager } from "react-notifications";

const DEFAULT_MESSAGES = {
	success: "Operação realizada com sucesso.",
	warning: "Atenção: verifique os dados e tente novamente.",
	error: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
};

export default function ResponseAlerts({
	response = null,
	navigate,
	navigateTo,
	successMessage,
	errorMessage,
	onClick,
} = {}) {
	if (!response) return;
	if (typeof response.status !== "number") {
		NotificationManager.error("", DEFAULT_MESSAGES.error, 5000, onClick);
		return;
	}

	const { status, data } = response;

	// Sucesso (200, 201, 204)
	if ([200, 201, 204].includes(status)) {
		if (typeof navigate === "function" && navigateTo) {
			navigate(navigateTo, { replace: true });
		}
		NotificationManager.success(
			"",
			successMessage || DEFAULT_MESSAGES.success,
			5000,
			onClick,
		);
		return;
	}

	// Erros de cliente (400–499)
	if (status >= 400 && status < 500) {
		const msg = (data && data.message) || DEFAULT_MESSAGES.warning;
		NotificationManager.warning("", msg, 5000, onClick);
		return;
	}

	// Erros de servidor (500+)
	NotificationManager.error(
		"",
		errorMessage || DEFAULT_MESSAGES.error,
		5000,
		onClick,
	);
}
